import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import NavLink from '../Routes/NavLink'
import {buildingGroups} from '../../core/controllers/BuildingGroups'

export default class GroupsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        }
        this.index = 0;
    }

    componentDidMount() {
        buildingGroups.getBuildingGroups(this);
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatActionOptions(cell, row) {
        return <NavLink to={/group/ + cell}><i class="fa fa-pencil-square-o"></i></NavLink>
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var groupsList = this.state.data;
        if(groupsList != null) {
            groupsList = groupsList.map(function(group) {
                return self.flattenObject(group);
            });
        }

        return (
            <div class="content">
                <div class="row">
                    <div class="col-md-12">
                        {groupsList != null ? (
                            <BootstrapTable data={groupsList} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='building_group_name' dataSort={ true }>Group Name</TableHeaderColumn>
                                <TableHeaderColumn dataField='building_group_created' dataSort={ true }>Creation Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='building_group_id' dataAlign='center' width="50" dataFormat={this.formatActionOptions}></TableHeaderColumn>
                            </BootstrapTable>
                        ) : (
                            <p>No groups currently found!</p>
                        )}
                    </div>
                </div>
                <div class="content">
                    <NavLink to={"/group/new"}>
                        <button type="button" id="add-group" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off">Add Group</button>
                        <div class="clearfix"></div>
                    </NavLink>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Groups/GroupsList.jsx